import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
} from "@ey-xd/motif-react";
import React from "react";
import "./confirmationModal.scss";
import Button from "@/components/Form/Button/Button";
import { useTranslation } from "react-i18next";
import {
  CANCEL_BUTTON_VARIANT,
  YES_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";

type Props = {
  isVisible: boolean;
  setIsVisible: any;
  cancelBtnRejectHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  cancelBtnApproveHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: number;
  heading?: string;
  message?: string | React.ReactNode;
  loading?: boolean;
  showHeader?: boolean;
};

export default function ConfirmationModal({
  isVisible,
  setIsVisible,
  cancelBtnRejectHandler,
  cancelBtnApproveHandler,
  type = 2,
  heading,
  message,
  loading = false,
  showHeader = true,
}: Props) {
  const { t } = useTranslation();
  const Btn_cancel_lable =
    type === 1
      ? "global.globalActions.cancel"
      : type === 3
      ? "global.globalActions.cancel"
      : type === 4
      ? "global.globalActions.cancel"
      : "global.globalActions.no";
  const Btn_Aproove_lable =
    type === 1
      ? "global.globalActions.discard"
      : type === 3
      ? "global.globalActions.confirm"
      : type === 4
      ? "global.globalActions.next"
      : "global.globalActions.yes";
  return (
    <>
      <MotifModal
        onClose={() => setIsVisible(false)}
        show={isVisible}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="confirmationModalWrapper">
          <MotifModalBody>
            {showHeader && (
              <span className="discard_heading">
                {heading || t("global.globalNotifications.unsavedChanges")}
              </span>
            )}
            <div className="discard_message">
              {message || t("global.globalNotifications.discardMessage")}
            </div>
          </MotifModalBody>
          <MotifModalFooter>
            <Button
              label={t(Btn_Aproove_lable)}
              variant={YES_BUTTON_VARIANT}
              className="delBtn"
              loading={loading}
              onClickHandler={cancelBtnApproveHandler}
            />
            <Button
              label={t(Btn_cancel_lable)}
              variant={CANCEL_BUTTON_VARIANT}
              className="cancelBtnModal"
              onClickHandler={cancelBtnRejectHandler}
            />
          </MotifModalFooter>
        </div>
      </MotifModal>
    </>
  );
}
